import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/#categories' },
  { name: '热门推荐', path: '/#hot-comics' },
  { name: '最新文章', path: '/#latest-articles' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
            </div>
            <span className="text-xl font-bold font-heading" style={{ color: scrolled || !isHome ? 'oklch(var(--foreground-900))' : '#fff' }}>
              韩漫世界
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/#hot-comics"
              className="px-5 py-2 text-sm font-medium rounded-full bg-primary-500 text-white whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-2xl ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-white'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap"
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/#hot-comics"
              className="px-5 py-2.5 text-sm font-medium rounded-full bg-primary-500 text-white text-center whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}